// import React, { useEffect, useState } from "react";
// import "./StartVideo.css";
// import { useNavigate } from "react-router-dom";

// export default function StartVideo() {
//   const navigate = useNavigate();
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const mobile = window.innerWidth <= 768;

//     if (!mobile) {
//       navigate("/home", { replace: true });
//       return;
//     }

//     setIsMobile(true);

//     const timer = setTimeout(() => {
//       navigate("/home", { replace: true });
//     }, 7000);

//     return () => clearTimeout(timer);
//   }, [navigate]);

//   if (!isMobile) return null;

//   return (
//     <div className="start-video-section">
//       <video
//         className="bg-video"
//         src="/assets/video/Falcon.mp4"
//         autoPlay
//         muted
//         playsInline
//       />
//     </div>
//   );
// }

import React, { useEffect } from "react";
import "./StartVideo.css";
import { useNavigate } from "react-router-dom";

export default function StartVideo() {
  const navigate = useNavigate();

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     navigate("/", { replace: true });
  //   }, 7000);

  //   return () => clearTimeout(timer);
  // }, [navigate]);
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 7000);

    return () => clearTimeout(timer);
  }, [navigate]);
  return (
    <div className="start-video-section">
      <video
        className="bg-video"
        src="/assets/video/Falcon.mp4"
        autoPlay
        muted
        playsInline
      />
    </div>
  );
}
